<template>
  <div>
    <loader v-if="isPending" class="c-loader" />
    <div v-else>
      <no-results v-if="!products.length" />

      <div class="c c-product-overview__grid">
        <product
          v-for="product in products"
          :key="product.id"
          :product="product"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from './loader.vue';
import Product from './product.vue';
import NoResults from './no-results.vue';

export default {
  components: {
    Product,
    Loader,
    NoResults
  },
  computed: {
    ...mapState('productSearch', ['isPending', 'products'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '~bootstrap/scss/mixins';

.c-product-overview__grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 20px;
  align-items: stretch;

  @include media-breakpoint-up(md) {
    gap: 30px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @include media-breakpoint-up(lg) {
    gap: 30px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.c-loader {
  padding-top: 125px;
  padding-bottom: 125px;
}
</style>
